module.exports = __webpack_public_path__ + "img/word.50fe0580.png";